module.exports = __webpack_public_path__ + "img/電気回路_6_9_2.31cd2498.png";